import {
  validateOfflineDatastore
} from "./chunk-7MOEOSG7.mjs";

// src/datastores/offline-datastore/offline-datastore.ts
var offlineDatastoreKey = "__yva-ds";
async function syncToOffline() {
  if (window.yvaDatastore) {
    let offlineDatastore2 = {
      contexts: window.yvaDatastore.contexts,
      events: window.yvaDatastore.events
    };
    localStorage.setItem(offlineDatastoreKey, JSON.stringify(offlineDatastore2));
  }
}
async function syncFromOffline() {
  return new Promise((resolve, reject) => {
    try {
      let offlineDatastore2 = localStorage.getItem(offlineDatastoreKey);
      if (offlineDatastore2) {
        const validDatastore = validateOfflineDatastore(JSON.parse(offlineDatastore2));
        resolve(validDatastore);
      } else {
        resolve(null);
      }
    } catch (error) {
      reject(error);
    }
  });
}
var offlineDatastore = {
  read: syncFromOffline,
  write: syncToOffline
};

export {
  offlineDatastoreKey,
  offlineDatastore
};
